import { Configuration } from "@freightsimple/generated-dashboard-openapi-client/runtime";
import { ShipmentsApi } from "@freightsimple/generated-dashboard-openapi-client/apis/ShipmentsApi";
import { useAuthentication } from "@/Slices/authenticationSlice";
import { getConfig } from "@/Apis/getConfig";

export function useShipmentsApi(): ShipmentsApi {
  const { accessToken } = useAuthentication();

  return new ShipmentsApi(
    new Configuration({ ...getConfig(), accessToken: accessToken }),
  );
}
